/**
 * Gets the border radius values for an item of content that goes right up to
 * the edges of its container, to the top, bottom, left or right of other content.
 *
 * Gives the full bleed item the same border radius as the container on the corners
 * that are flush with the corners of the container.
 *
 * @param {number} borderRadius
 * @param {'top'|'bottom'|'left'|'right'} position
 * @param {boolean} hasFooter
 * @returns
 */
const getFullBleedBorderRadius = function (borderRadius, position) {
  let hasFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const innerBorderRadius = {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  };
  if (position && position !== 'none') {
    if (borderRadius) {
      // Depending on the position of the image, we need to round some
      // corners, but not the others
      switch (position) {
        case 'bottom':
          if (!hasFooter) {
            innerBorderRadius.borderBottomLeftRadius = borderRadius;
            innerBorderRadius.borderBottomRightRadius = borderRadius;
          }
          break;
        case 'left':
          if (!hasFooter) {
            innerBorderRadius.borderBottomLeftRadius = borderRadius;
          }
          innerBorderRadius.borderTopLeftRadius = borderRadius;
          break;
        case 'right':
          if (!hasFooter) {
            innerBorderRadius.borderBottomRightRadius = borderRadius;
          }
          innerBorderRadius.borderTopRightRadius = borderRadius;
          break;
        case 'top':
          innerBorderRadius.borderTopLeftRadius = borderRadius;
          innerBorderRadius.borderTopRightRadius = borderRadius;
          break;
        default:
          break;
      }
    }
  }
  return innerBorderRadius;
};
export default getFullBleedBorderRadius;